export default "__VITE_ASSET__3Rvf6PKB__"